import { render, staticRenderFns } from "./legend-document-form.vue?vue&type=template&id=420e65ac&scoped=true"
import script from "./legend-document-form.vue?vue&type=script&lang=js"
export * from "./legend-document-form.vue?vue&type=script&lang=js"
import style0 from "./legend-document-form.vue?vue&type=style&index=0&id=420e65ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420e65ac",
  null
  
)

export default component.exports